export const environment = {
  production: false,

  environment: 'Dev',

  authorized: {
    url: "https://login.microsoftonline.com/4eb911de-063e-41cb-bcf9-71aabf223544/oauth2/v2.0/authorize",
    clientId: '89d1ae6e-bfcb-411c-ab1a-c66fec999e66',
    redirectUrl: 'https://thankful-mud-04b0edc03.3.azurestaticapps.net/oauthresponse',
    scope: 'https://preintranet.ahorramas.com/Read'
  },

  storageType: 'sessionStorage', // Opciones disponibles actualmente: sessionStorage, localStorage

  uiService: {
    url: 'https://apides.ahorramas.com/ahoramas-dev'
  },

};
